export default __webpack_public_path__ + "m_bg4d911e7.png";